import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  fill?: string;
  stroke?: string;
  style?: any;
}

const ArrowIcon: React.FC<Props> = ({
  fill = 'none',
  stroke = '#450A0A',
  style
}) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill={fill}
      style={style}
    >
      <path
        d="m6 9 6 6 6-6"
        stroke={stroke}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);
export { ArrowIcon };
